import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { SchedoraLogo } from "@/components/schedora/SchedoraLogo";
import { useApp } from "@/context/AppContext";

export default function ForgotPassword() {
  const { requestPasswordReset } = useApp();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <SchedoraLogo textClassName="text-xl" />
        </Link>
        {!sent ? (
          <>
            <h1 className="text-2xl font-heading font-bold text-foreground">Reset password</h1>
            <p className="mt-1 text-sm text-muted-foreground">We'll send you a link to reset your password.</p>
            <form
              className="mt-6 space-y-4"
              onSubmit={async (e) => {
                e.preventDefault();
                setError("");
                if (!email.trim() || !email.includes("@")) {
                  setError("Enter a valid email address.");
                  return;
                }
                setIsSubmitting(true);
                const result = await requestPasswordReset(email);
                if (!result.ok) {
                  setError(result.message);
                  setIsSubmitting(false);
                  return;
                }
                setSent(true);
              }}
            >
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1"
                />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button className="w-full" type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : "Send Reset Link"}
              </Button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-success/10 mb-4">
              <SchedoraLogo iconOnly iconClassName="h-6 w-6 text-success" />
            </div>
            <h1 className="text-2xl font-heading font-bold text-foreground">Check your email</h1>
            <p className="mt-2 text-sm text-muted-foreground">We sent a reset link to {email}. It will bring you back to Schedora to set a new password.</p>
          </div>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm text-primary hover:underline">
          <ArrowLeft className="h-3.5 w-3.5" /> Back to login
        </Link>
      </div>
    </div>
  );
}
